var Backbone, BreadcrumbIndexTemplate, BreadcrumbView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

BreadcrumbIndexTemplate = require('../../index.html.mustache');

module.exports = BreadcrumbView = (function(superClass) {
  var BREADCRUMB_SELECTOR;

  extend(BreadcrumbView, superClass);

  BREADCRUMB_SELECTOR = '#breadcrumb-container';

  BreadcrumbView.prototype.template = BreadcrumbIndexTemplate;

  function BreadcrumbView(presenter) {
    var $module, breadcrumb;
    this.presenter = presenter;
    breadcrumb = this.presenter.breadcrumb;
    if (!$(BREADCRUMB_SELECTOR).length) {
      return;
    }
    $module = $(BREADCRUMB_SELECTOR);
    this.$el = $module;
  }

  BreadcrumbView.prototype.render = function() {
    return this.$el.replaceWith(this.toHtml());
  };

  BreadcrumbView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  BreadcrumbView.prototype.getSelector = function() {
    var selector;
    selector = $(BREADCRUMB_SELECTOR);
    if (selector.length) {
      return selector;
    }
  };

  return BreadcrumbView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icmVhZGNydW1iL2Zyb250ZW5kL3ZpZXdzL2JyZWFkY3J1bWIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icmVhZGNydW1iL2Zyb250ZW5kL3ZpZXdzL2JyZWFkY3J1bWIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsaURBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSwyQkFBUjs7QUFFMUIsTUFBTSxDQUFDLE9BQVAsR0FBdUI7QUFDckIsTUFBQTs7OztFQUFBLG1CQUFBLEdBQXNCOzsyQkFFdEIsUUFBQSxHQUFVOztFQUVHLHdCQUFDLFNBQUQ7QUFDWCxRQUFBO0lBRFksSUFBQyxDQUFBLFlBQUQ7SUFDWCxhQUFjLElBQUMsQ0FBQTtJQUNoQixJQUFBLENBQWMsQ0FBQSxDQUFFLG1CQUFGLENBQXNCLENBQUMsTUFBckM7QUFBQSxhQUFBOztJQUVBLE9BQUEsR0FBVSxDQUFBLENBQUUsbUJBQUY7SUFDVixJQUFDLENBQUEsR0FBRCxHQUFPO0VBTEk7OzJCQU9iLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxXQUFMLENBQWlCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBakI7RUFETTs7MkJBR1IsTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsUUFBUSxDQUFDLE1BQVYsQ0FBaUIsSUFBQyxDQUFBLFNBQWxCO0VBRE07OzJCQUdSLFdBQUEsR0FBYSxTQUFBO0FBQ1gsUUFBQTtJQUFBLFFBQUEsR0FBVyxDQUFBLENBQUUsbUJBQUY7SUFDWCxJQUFtQixRQUFRLENBQUMsTUFBNUI7QUFBQSxhQUFPLFNBQVA7O0VBRlc7Ozs7R0FsQitCLFFBQVEsQ0FBQyJ9
